import React, {Component} from 'react';
import Kalendaryo from 'kalendaryo';
import CalendarComponent from './CalendarComponents';
import {isAfter, differenceInDays} from 'date-fns';

class Calendar extends Component {
  state = {
    startDate: null,
    endDate: null,
  };

  componentDidMount() {
    if (this.props.value) {
      this.setState(this.props.value);
    }
  }

  setDateRange = selectedDate => {
    const {startDate, endDate} = this.state;
    const rangeSelected = startDate && endDate && differenceInDays(startDate, endDate) !== 0;

    // Nothing selected yet, or a full range is already selected:
    // start a fresh single-day selection on the clicked day.
    if (!startDate || rangeSelected) {
      this.setState({startDate: selectedDate, endDate: selectedDate}, () => this.props.onChange(this.state));
      return;
    }

    // A single day is selected (startDate === endDate).
    // Clicking that same day again clears the selection.
    if (differenceInDays(selectedDate, startDate) === 0) {
      this.setState({startDate: null, endDate: null}, () => this.props.onChange(this.state));
      return;
    }

    // Clicking a later day extends the single day into a range.
    if (isAfter(selectedDate, startDate)) {
      this.setState({endDate: selectedDate}, () => this.props.onChange(this.state));
      return;
    }

    // Clicking an earlier day extends the range backwards.
    this.setState({startDate: selectedDate}, () => this.props.onChange(this.state));
  };

  render() {
    return (
      <Kalendaryo
        startDate={this.state.startDate}
        endDate={this.state.endDate}
        onSelectedChange={this.setDateRange}
        startWeekAt={1}
        defaultFormat={'YYYY-MM-DD'}
        render={CalendarComponent}
      />
    );
  }
}

export default Calendar;
